import {Box, styled} from '@mui/material';

interface StyledBoxProviderProps {
	$isNewProvider: boolean;
}

const StyledBoxProvider = styled(Box)<StyledBoxProviderProps>`
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 6px 12px;
	border-radius: 8px 8px 0 0;

	background-color: ${({theme, $isNewProvider}) =>
		$isNewProvider
			? theme.colors.light.primary['20Percent']
			: theme.colors.light.primary.neutral};
`;

export default StyledBoxProvider;
